var map = {
	"./Nursery_0.png": 1279,
	"./Nursery_1.png": 1280,
	"./Nursery_2.png": 1281,
	"./Nursery_3.png": 1282,
	"./Nursery_4.png": 1283,
	"./Nursery_5.png": 1284,
	"./Nursery_6.png": 1285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1278;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery ^\.\/Nursery_.*\.png$
// module id = 1278
// module chunks = 3